<!-- <p>incident-categories works!</p> -->
<div class="demo-chart-wrapper">
  <div echarts [options]="chartOption" class="demo-chart"></div>
</div>
